import { cn } from '../../lib/cn';
import type { ProductReleaseRow } from '../../enterprisega/framework';

type Props = { items?: ProductReleaseRow[] };

export function ProductReleaseOpsPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={`${item.category}-${item.name}`} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div>
            <p className="text-xs text-slate-500">{item.category}</p>
            <p className="text-sm font-medium">{item.name}</p>
            <p className="text-xs text-slate-500">{item.value}</p>
          </div>
          <span className={cn(
            'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
            item.status === 'shipped' || item.status === 'strong' ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300' :
            'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300',
          )}>
            {item.status}
          </span>
        </div>
      ))}
    </div>
  );
}
